module.exports = __webpack_public_path__ + "img/C73528.e296cd71.png";